import { AgreementState } from "../../states/agreement.state";
import { ContractDetailState } from "../../states/contract-detail.state";
import { CounterProposalState } from "../../states/counter-proposal.state";
import { IntelligentProposalState } from "../../states/intelligent-proposal.state";
import { NoOfferContractState } from "../../states/no-offer.state";
import { PreApprovedState } from "../../states/pre-approved.state";

export const STATES_WITH_RESET_IN_HOME = [
  PreApprovedState,
  AgreementState,
  ContractDetailState,
  NoOfferContractState,
  IntelligentProposalState,
  CounterProposalState,
];